import {
  HANDLING_CODES,
  ERROR_PAGES,
  WEB_SERVICES,
  CUSTOM_ERRORS,
} from './utils';

const webServiceErrorHandler = {
  // INIT PURCHASE
  [WEB_SERVICES.INIT_PURCHASE_BAF]: {
    service: WEB_SERVICES.INIT_PURCHASE_BAF,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      461: HANDLING_CODES.FATAL,
      [CUSTOM_ERRORS.EMPTY_CONTACT_MEDIA?.status]: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
      461: ERROR_PAGES.ALREADY_PURCHASE_BAF_ERROR_PAGE,
      [CUSTOM_ERRORS.EMPTY_CONTACT_MEDIA?.status]:
        ERROR_PAGES.EMPTY_CONTACT_MEDIA_ERROR_PAGE,
    },
  },
  [WEB_SERVICES.INIT_PURCHASE_MOBILE_LINE]: {
    service: WEB_SERVICES.INIT_PURCHASE_MOBILE_LINE,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      454: HANDLING_CODES.FATAL,
      455: HANDLING_CODES.FATAL,
      [CUSTOM_ERRORS.EMPTY_CONTACT_MEDIA?.status]: HANDLING_CODES.FATAL,
      [CUSTOM_ERRORS.INCOMPATIBLE_PROMOTION?.status]: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
      454: ERROR_PAGES.INCOMPATIBLE_LMC_BUNDLE_ERROR_PAGE,
      455: ERROR_PAGES.INCOMPATIBLE_LMA_ERROR_PAGE,
      [CUSTOM_ERRORS.EMPTY_CONTACT_MEDIA?.status]:
        ERROR_PAGES.EMPTY_CONTACT_MEDIA_ERROR_PAGE,
      [CUSTOM_ERRORS.INCOMPATIBLE_PROMOTION?.status]:
        ERROR_PAGES.INCOMPATIBLE_PROMOTION_PAGE,
    },
  },
  [WEB_SERVICES.INIT_PURCHASE_ADDITIONAL_FIBER]: {
    service: WEB_SERVICES.INIT_PURCHASE_ADDITIONAL_FIBER,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      461: HANDLING_CODES.FATAL,
      409: HANDLING_CODES.FATAL,
      401: HANDLING_CODES.FATAL,
      [CUSTOM_ERRORS.EMPTY_CONTACT_MEDIA?.status]: HANDLING_CODES.FATAL,
      419: HANDLING_CODES.FATAL,
      423: HANDLING_CODES.FATAL,
      462: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
      461: ERROR_PAGES.ALREADY_PURCHASE_ADDITIONAL_FIBER_ERROR_PAGE,
      409: ERROR_PAGES.INCOMPATIBLE_ADDITIONAL_FIBER_ERROR_PAGE,
      [CUSTOM_ERRORS.EMPTY_CONTACT_MEDIA?.status]:
        ERROR_PAGES.EMPTY_CONTACT_MEDIA_ERROR_PAGE,
      419: ERROR_PAGES.PROMO_EXPIRED_FA_ERROR_PAGE,
      423: ERROR_PAGES.PROMO_EXPIRED_FA_ERROR_PAGE,
      462: ERROR_PAGES.ALREADY_PURCHASE_PROMO_FA_ERROR_PAGE,
    },
  },
  [WEB_SERVICES.INIT_PURCHASE_MIMOVISTAR_NO_CLIENTE]: {
    service: WEB_SERVICES.INIT_PURCHASE,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      463: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
      463: ERROR_PAGES.WRONG_ZONE_MIMOVISTAR_NO_CLIENTE,
    },
  },
  [WEB_SERVICES.INIT_PURCHASE_TV]: {
    service: WEB_SERVICES.INIT_PURCHASE_TV,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      461: HANDLING_CODES.FATAL,
      419: HANDLING_CODES.FATAL,
      423: HANDLING_CODES.FATAL,
      462: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT_TV,
      461: ERROR_PAGES.ALREADY_PURCHASE_TV_ERROR_PAGE,
      419: ERROR_PAGES.PROMO_EXPIRED_TV_ERROR_PAGE,
      423: ERROR_PAGES.PROMO_EXPIRED_TV_ERROR_PAGE,
      462: ERROR_PAGES.ALREADY_PURCHASE_PROMO_TV_ERROR_PAGE,
    },
  },
  // SET INFO
  [WEB_SERVICES.SET_INFO_BAF]: {
    service: WEB_SERVICES.SET_INFO_BAF,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
    },
  },
  [WEB_SERVICES.SET_INFO_MOBILE_LINE]: {
    service: WEB_SERVICES.SET_INFO_MOBILE_LINE,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
    },
  },
  [WEB_SERVICES.SET_INFO_ADDITIONAL_FIBER]: {
    service: WEB_SERVICES.SET_INFO_ADDITIONAL_FIBER,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
    },
  },
  [WEB_SERVICES.SET_INFO_MAPS]: {
    service: WEB_SERVICES.SET_INFO_MAPS,
    handlingCode: {
      default: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: {},
  },
  [WEB_SERVICES.SET_INFO_MIMOVISTAR_NO_CLIENTE]: {
    service: WEB_SERVICES.SET_INFO_MIMOVISTAR_NO_CLIENTE,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      463: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT,
      463: ERROR_PAGES.WRONG_ZONE_MIMOVISTAR_NO_CLIENTE,
    },
  },
  // CHECK OUT
  [WEB_SERVICES.CHECKOUT]: {
    service: WEB_SERVICES.CHECKOUT,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.CHECKOUT,
    },
  },
  [WEB_SERVICES.CHECKOUT_TV]: {
    service: WEB_SERVICES.CHECKOUT_TV,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT_TV,
    },
  },
  // PROCESS ORDER
  [WEB_SERVICES.PROCESS_ORDER]: {
    service: WEB_SERVICES.PROCESS_ORDER,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.CHECKOUT,
    },
  },
  [WEB_SERVICES.PROCESS_ORDER_TV]: {
    service: WEB_SERVICES.PROCESS_ORDER_TV,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT_TV,
    },
  },
  // SEND SMS
  [WEB_SERVICES.SEND_SMS_OTP]: {
    service: WEB_SERVICES.SEND_SMS_OTP,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.CHECKOUT,
    },
  },
  [WEB_SERVICES.SEND_SMS_OTP_TV]: {
    service: WEB_SERVICES.SEND_SMS_OTP_TV,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT_TV,
    },
  },
  // VALIDATE SMS
  [WEB_SERVICES.VALIDATE_SMS_OTP]: {
    service: WEB_SERVICES.VALIDATE_SMS_OTP,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      457: HANDLING_CODES.NOTHING_TO_DO,
      456: HANDLING_CODES.NOTHING_TO_DO,
      [CUSTOM_ERRORS.ALREADY_CLIENT?.status]: HANDLING_CODES.FATAL,
    },
    errorToPrint: {
      default: ERROR_PAGES.CHECKOUT,
      [CUSTOM_ERRORS.ALREADY_CLIENT?.status]: ERROR_PAGES.ALREADY_CLIENT,
    },
  },
  [WEB_SERVICES.VALIDATE_SMS_OTP_TV]: {
    service: WEB_SERVICES.VALIDATE_SMS_OTP_TV,
    handlingCode: {
      default: HANDLING_CODES.FATAL,
      457: HANDLING_CODES.NOTHING_TO_DO,
      456: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: {
      default: ERROR_PAGES.DEFAULT_TV,
    },
  },
  // RETARGETING
  [WEB_SERVICES.RETARGETING]: {
    service: WEB_SERVICES.RETARGETING,
    handlingCode: {
      default: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: {},
  },
  // APPOINTMENT
  [WEB_SERVICES.GET_EXTRA_APPOINTMENT_OPTIONS]: {
    service: WEB_SERVICES.GET_EXTRA_APPOINTMENT_OPTIONS,
    handlingCode: {
      default: HANDLING_CODES.NOTHING_TO_DO,
    },
    errorToPrint: {},
  },
};

export default webServiceErrorHandler;
